import { gql } from 'react-apollo';

import getAllSubscriptionQuery from '../routes/subscription/getAllSubscriptionQuery.graphql';

// Toaster
import { toastr } from 'react-redux-toastr';

import {
    MANANGE_SUBSCRIPTION_STATUS_START,
    MANANGE_SUBSCRIPTION_STATUS_SUCCESS,
    MANANGE_SUBSCRIPTION_STATUS_ERROR,
} from '../constants';
import UserType from '../data/types/UserType';

// To Refresh the Subscription Status
/* const getSubscriptionQuery = gql`
    query getSubscription {
        getSubscription {
            id
            active
        }
  }`; */

export function manageSubscriptionStatus(subscriptionId, action) {

    return async (dispatch, getState, { client }) => {

        dispatch({
            type: MANANGE_SUBSCRIPTION_STATUS_START,
            payload: {
              manageSubscriptionStatusLoading: true
            }
        });

        let mutation = gql`
            mutation ManageSubscriptionStatus($subscriptionId: Int!, $action: String!) {
                ManageSubscriptionStatus(subscriptionId: $subscriptionId, action: $action) {
                    status
                }
            }
        `;

        try {
          let type = 'Cancel Subscription';

          const { data } = await client.mutate({
            mutation,
            variables: {
              subscriptionId,
              action
            },
            refetchQueries: [
              { query: getAllSubscriptionQuery,
                variables: {
                  userType: 'guest',
                  currentPage: 1,
                  subscriptionStatus: true
                }
               },
            ]
          });

          if (data.ManageSubscriptionStatus.status === '200') {
            dispatch({
              type: MANANGE_SUBSCRIPTION_STATUS_SUCCESS,
              payload: {
                manageSubscriptionStatusLoading: false
              }
            });
          } else {
            toastr.error(type, 'Failed');
            dispatch({
              type: MANANGE_SUBSCRIPTION_STATUS_ERROR,
              payload: {
                manageSubscriptionStatusLoading: false
              }
            });
          }
        } catch (error) {
            dispatch({
                type: MANANGE_SUBSCRIPTION_STATUS_ERROR,
                payload: {
                  error,
                  manageSubscriptionStatusLoading: false
                }
            });
        }
    };
}



// WEBPACK FOOTER //
// src/actions/manageSubscriptionStatus.js